import {createRouter, createWebHistory} from "vue-router";
import MessageView from "../views/MessageView.vue";
import ChatView from "@/views/Chat/ChatView.vue";
import GroupView from "@/views/Group/GroupView.vue";
import GroupChildView from "@/views/Group/GroupChildView.vue";
import ErrorsView from "@/views/ErrorsView.vue";
import AccountView from "@/views/AccountView.vue";
import SavedView from "@/views/SavedView.vue";
import ShiftsView from "@/views/ShiftsView.vue";
import ChatChildView from "@/views/Chat/ChatChildView.vue";
import LoginView from "@/views/Auth/LoginView.vue";
import AuthLayout from "@/layouts/AuthLayout.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import UnauthorizedView from "@/views/Error/UnauthorizedView.vue";
import {getToken} from "@/utils/token";
import PermissionView from "@/views/Error/PermissionView.vue";
import NotFoundView from "@/views/Error/NotFoundView.vue";
import ErrorView from "@/views/Error/ErrorView.vue";
import ContactsView from "@/views/ContactsView.vue";
import SettingsView from "@/views/SettingsView.vue";

const routes = [
    {
        path: "/",
        name: "home",
        redirect: "/auth/sign-in",
        component: LoginView,
    },
    {
        path: "/auth/sign-in",
        component: AuthLayout,
        meta: {guest: true},
        children: [
            {
                path: "",
                name: "SignIn",
                component: LoginView,
            },
        ],
    },

    {
        path: "/",
        component: MainLayout,
        meta: {requiresAuth: true},
        children: [
            {
                path: "message",
                name: "Message",
                component: MessageView,
            },
            {
                path: "/chat",
                name: "chat",
                component: ChatView,
            },
            {
                path: "/chat/:id",
                name: "chat-child",
                component: ChatChildView,
            },
            {
                path: "/group",
                name: "group",
                component: GroupView,
            },
            {
                path: "/group/:id",
                component: GroupChildView,
            },
            {
                path: "/errors",
                name: "errors",
                component: ErrorsView,
            },
            {
                path: "/account",
                name: "account",
                component: AccountView,
            },
            {
                path: "/saved",
                name: "saved",
                component: SavedView,
            },
            {
                path: "/shifts",
                name: "shifts",
                component: ShiftsView,
            },
            {
                path: "/contacts",
                name: "contacts",
                component: ContactsView
            },
            {
                path: "/settings",
                name: "settings",
                component: SettingsView,
            },
        ],
    },

    {
        path: "/401",
        name: "401",
        component: UnauthorizedView,
    },
    {
        path: "/402",
        name: "402",
        component: PermissionView,
    },
    {
        path: "/403",
        name: "403",
        component: PermissionView,
    },
    {
        path: "/404",
        name: "404",
        component: NotFoundView,
    },
    {
        path: "/error-page",
        name: "error-page",
        component: ErrorView,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to: any, _from: any, next: any) => {
    const token = getToken()

    if (to.meta.requiresAuth && !token) {
        next('/auth/sign-in')
    } else if (to.meta.guest && token) {
        next('/message')
    } else {
        next()
    }
})

export default router;
